module.exports = __webpack_public_path__ + "static/img/A6.335aa133.jpg";